import React, { Component } from 'react';
import '../css/home.css';
import CoursesDashboard from './CoursesDashboard';
 


export default class Home extends Component {
  componentWillUpdate() {
    console.debug('componentWillUpdate');
    this.addBreadCrumbs();
  }

  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([]);
  };

  render() {
    return (
      <div className="home">
        <div style={{ marginTop: '10px' }}>
          <CoursesDashboard />
        </div>
      </div>
    );
  }
}
